"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionVideoAvailability_1 = require("../meetingsession/MeetingSessionVideoAvailability");

var DefaultModality_1 = require("../modality/DefaultModality");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var Types_1 = require("../utils/Types");

var BaseTask_1 = require("./BaseTask");
/*
 * [[ReceiveVideoStreamIndexTask]] receives [[SdkIndexFrame]] and updates [[VideoUplinkBandwidthPolicy]] and [[VideoDownlinkBandwidthPolicy]].
 */


var ReceiveVideoStreamIndexTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ReceiveVideoStreamIndexTask, _BaseTask_1$default);

  var _super = _createSuper(ReceiveVideoStreamIndexTask);

  function ReceiveVideoStreamIndexTask(context) {
    var _this;

    _classCallCheck(this, ReceiveVideoStreamIndexTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ReceiveVideoStreamIndexTask'; // See comment above invocation of `pauseIngestion` in `DefaultAudioVideoController`
    // for explanation.

    _this.isIngestionPaused = false;
    _this.pendingIndex = null;
    return _this;
  }

  _createClass(ReceiveVideoStreamIndexTask, [{
    key: "removeObserver",
    value: function removeObserver() {
      this.context.signalingClient.removeObserver(this);
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.handleIndexFrame(this.context.indexFrame);
                this.context.signalingClient.registerObserver(this);
                this.context.removableObservers.push(this);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "handleSignalingClientEvent",
    value: function handleSignalingClientEvent(event) {
      if (event.type !== SignalingClientEventType_1.default.ReceivedSignalFrame || event.message.type !== SignalingProtocol_js_1.SdkSignalFrame.Type.INDEX) {
        return;
      } // @ts-ignore: force cast to SdkIndexFrame


      var indexFrame = event.message.index;
      this.context.logger.info("received new index ".concat(JSON.stringify(indexFrame)));
      this.handleIndexFrame(indexFrame);
    }
  }, {
    key: "pauseIngestion",
    value: function pauseIngestion() {
      this.isIngestionPaused = true;
    }
  }, {
    key: "resumeIngestion",
    value: function resumeIngestion() {
      if (!this.isIngestionPaused) {
        // Do not recheck subcribe if it wasn't paused to begin with.
        return;
      }

      this.isIngestionPaused = false;

      if (this.pendingIndex) {
        this.context.logger.info('Resuming index ingestion with pending index');
        this.handleIndexFrame(this.pendingIndex);
      }
    }
  }, {
    key: "handleIndexFrame",
    value: function handleIndexFrame(indexFrame) {
      if (!indexFrame) {
        return;
      }

      if (this.isIngestionPaused) {
        this.context.logger.info("Index ingestion is paused, setting most recent index as pending");
        this.pendingIndex = indexFrame;
        return;
      } else {
        this.pendingIndex = null;
      } // Filter out self content share video


      var selfAttendeeId = this.context.audioVideoController.configuration.credentials.attendeeId;
      indexFrame.sources = indexFrame.sources.filter(function (source) {
        var modality = new DefaultModality_1.default(source.attendeeId);
        return !(modality.base() === selfAttendeeId && modality.hasModality(DefaultModality_1.default.MODALITY_CONTENT));
      });
      var _this$context = this.context,
          videoStreamIndex = _this$context.videoStreamIndex,
          videoDownlinkBandwidthPolicy = _this$context.videoDownlinkBandwidthPolicy,
          videoUplinkBandwidthPolicy = _this$context.videoUplinkBandwidthPolicy;
      var oldVideoSources = videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);
      videoStreamIndex.integrateIndexFrame(indexFrame);
      videoDownlinkBandwidthPolicy.updateIndex(videoStreamIndex);
      videoUplinkBandwidthPolicy.updateIndex(videoStreamIndex);
      this.resubscribe(videoDownlinkBandwidthPolicy, videoUplinkBandwidthPolicy);
      this.updateVideoAvailability(indexFrame);
      this.handleIndexVideosPausedAtSource(); // `forEachObserver`is asynchronous anyways so it doesn't matter (for better or worse) whether we
      // trigger it before or after the policy update + possible resubscribe kickoff

      var newVideoSources = videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);

      if (!this.areVideoSourcesEqual(oldVideoSources, newVideoSources)) {
        this.context.audioVideoController.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.remoteVideoSourcesDidChange).map(function (f) {
            return f.bind(observer)(newVideoSources);
          });
        });
      }
    }
  }, {
    key: "areVideoSourcesEqual",
    value: function areVideoSourcesEqual(oldVideoSources, newVideoSources) {
      if (oldVideoSources.length !== newVideoSources.length) {
        return false;
      }

      var compare = function compare(videoSourceA, videoSourceB) {
        return videoSourceA.attendee.attendeeId.localeCompare(videoSourceB.attendee.attendeeId);
      };

      var sortedOldVideoSources = _toConsumableArray(oldVideoSources).sort(compare);

      var sortedNewVideoSources = _toConsumableArray(newVideoSources).sort(compare);

      for (var i = 0; i < sortedOldVideoSources.length; i++) {
        if (sortedOldVideoSources[i].attendee.attendeeId !== sortedNewVideoSources[i].attendee.attendeeId) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "resubscribe",
    value: function resubscribe(videoDownlinkBandwidthPolicy, videoUplinkBandwidthPolicy) {
      var resubscribeForDownlink = videoDownlinkBandwidthPolicy.wantsResubscribe();
      var resubscribeForUplink = (this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.TX || this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.DUPLEX) && videoUplinkBandwidthPolicy.wantsResubscribe();
      var shouldResubscribe = resubscribeForDownlink || resubscribeForUplink;
      this.logger.info("should resubscribe: ".concat(shouldResubscribe, " (downlink: ").concat(resubscribeForDownlink, " uplink: ").concat(resubscribeForUplink, ")"));

      if (!shouldResubscribe) {
        return;
      }

      this.context.videosToReceive = videoDownlinkBandwidthPolicy.chooseSubscriptions();
      this.context.videoCaptureAndEncodeParameter = videoUplinkBandwidthPolicy.chooseCaptureAndEncodeParameters();
      this.logger.info("trigger resubscribe for up=".concat(resubscribeForUplink, " down=").concat(resubscribeForDownlink, "; videosToReceive=[").concat(this.context.videosToReceive.array(), "] captureParams=").concat(JSON.stringify(this.context.videoCaptureAndEncodeParameter)));
      this.context.audioVideoController.update({
        needsRenegotiation: false
      });
    }
  }, {
    key: "updateVideoAvailability",
    value: function updateVideoAvailability(indexFrame) {
      if (!this.context.videosToReceive) {
        this.logger.error('videosToReceive must be set in the meeting context.');
        return;
      }

      var videoAvailability = new MeetingSessionVideoAvailability_1.default();
      videoAvailability.remoteVideoAvailable = !this.context.videosToReceive.empty();
      videoAvailability.canStartLocalVideo = !indexFrame.atCapacity;

      if (!this.context.lastKnownVideoAvailability || !this.context.lastKnownVideoAvailability.equal(videoAvailability)) {
        this.context.lastKnownVideoAvailability = videoAvailability.clone();
        this.context.audioVideoController.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.videoAvailabilityDidChange).map(function (f) {
            return f.bind(observer)(videoAvailability.clone());
          });
        });
      }
    }
  }, {
    key: "handleIndexVideosPausedAtSource",
    value: function handleIndexVideosPausedAtSource() {
      var streamsPausedAtSource = this.context.videoStreamIndex.streamsPausedAtSource();

      var _iterator = _createForOfIteratorHelper(this.context.videoTileController.getAllVideoTiles()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tile = _step.value;
          var tileState = tile.state();

          if (streamsPausedAtSource.contain(tileState.streamId)) {
            if (tile.markPoorConnection()) {
              this.logger.info("marks the tile ".concat(tileState.tileId, " as having a poor connection"));
            }
          } else {
            if (tile.unmarkPoorConnection()) {
              this.logger.info("unmarks the tile ".concat(tileState.tileId, " as having a poor connection"));
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return ReceiveVideoStreamIndexTask;
}(BaseTask_1.default);

exports.default = ReceiveVideoStreamIndexTask;